import axios from 'axios';
// Set real endpoints here. Do not put secret API keys in frontend source.
export const baselineConfig = {
  mock: false, // false = use real API
  mockScenario: 'history', // 'empty' = No Baseline Data
  historyUrl: process.env.REACT_APP_SIGMA_BASELINE_LOG_URL || 'https://apigw-aws.cpfmes.com/mes/apigw/sigma-track-giveaway/baseline/log',
  switchUrl: process.env.REACT_APP_SIGMA_BASELINE_SWITCH_URL || 'https://apigw-aws.cpfmes.com/mes/apigw/sigma-track-giveaway/baseline/switch/',
  // Required for Export All: implement using the actual backend's all-records
  // endpoint or pagination contract. Must return every record, not latest 10.
  fetchAll: null,
  getHeaders: () => ({
    authorizationToken:
      "lFao}A!iCSg3v'sT{=*p*irT2f@#.X(9.1B:M9R'z*Qy=y\\F--Jme7EAQ){-A2x)",
  }),
};


// In-memory mock data only. Reload the browser to reset.
const MOCK_INITIAL_ROWS = [
  {
    "id": 1,
    "no": 1,
    "cl": 458.55,
    "lcl": 453.78,
    "ucl": 463.32,
    "sigma": 1.59,
    "source": "Initial",
    "passed_tracks": [],
    "shift_count": 45,
    "diff_cl_percent": null,
    "diff_sigma_percent": null,
    "switch_back_to_id": null,
    "date": "2026-06-02 13:00:11.243377+00:00",
    "can_switch": true,
    "performed_by": "ระบบ",
    "reason": "",
    "status": "-"
  },
  {
    "id": 7,
    "no": 2,
    "cl": 452.3478,
    "lcl": 447.5013,
    "ucl": 457.1944,
    "sigma": 1.6155,
    "source": "Auto",
    "passed_tracks": [
      "Track 1"
    ],
    "shift_count": 23,
    "diff_cl_percent": -0.013526,
    "diff_sigma_percent": 0.016046,
    "switch_back_to_id": null,
    "date": "2026-07-02 13:00:11.243377+00:00",
    "can_switch": true,
    "performed_by": "ระบบ",
    "reason": "",
    "status": "-"
  },
  {
    "id": 8,
    "no": 3,
    "cl": 458.55,
    "lcl": 453.78,
    "ucl": 463.32,
    "sigma": 1.59,
    "source": "Switch back",
    "passed_tracks": [],
    "shift_count": 0,
    "diff_cl_percent": 0.013711,
    "diff_sigma_percent": -0.015785,
    "switch_back_to_id": 1,
    "date": "2026-08-01 13:00:11.243377+00:00",
    "can_switch": false,
    "performed_by": "ผู้ใช้งาน",
    "reason": "Test switch back dry run",
    "status": "-"
  },
  {
    "id": 9,
    "no": 4,
    "cl": 458.5515,
    "lcl": 455.6943,
    "ucl": 461.4087,
    "sigma": 0.9524,
    "source": "Auto",
    "passed_tracks": [
      "Track 2"
    ],
    "shift_count": 25,
    "diff_cl_percent": 3e-06,
    "diff_sigma_percent": -0.401004,
    "switch_back_to_id": null,
    "date": "2026-08-31 13:00:11.243377+00:00",
    "can_switch": false,
    "performed_by": "ระบบ",
    "reason": "",
    "status": "-"
  },
  {
    "id": 10,
    "no": 5,
    "cl": 458.55,
    "lcl": 453.78,
    "ucl": 463.32,
    "sigma": 1.59,
    "source": "Switch back",
    "passed_tracks": [],
    "shift_count": 0,
    "diff_cl_percent": -0.013529,
    "diff_sigma_percent": 0.696241,
    "switch_back_to_id": 7,
    "date": "2026-09-30 13:00:11.243377+00:00",
    "can_switch": false,
    "performed_by": "ผู้ใช้งาน",
    "reason": "Test switch back dry run",
    "status": "-"
  },
  {
    "id": 11,
    "no": 6,
    "cl": 459.3452,
    "lcl": 454.5833,
    "ucl": 464.1072,
    "sigma": 1.5873,
    "source": "Auto",
    "passed_tracks": [
      "Track 1"
    ],
    "shift_count": 25,
    "diff_cl_percent": 0.001734,
    "diff_sigma_percent": -0.001682,
    "switch_back_to_id": null,
    "date": "2026-10-26 06:00:23.808293+00:00",
    "can_switch": true,
    "performed_by": "ระบบ",
    "reason": "",
    "status": "-"
  },
  {
    "id": 12,
    "no": 7,
    "cl": 458.5515,
    "lcl": 455.6943,
    "ucl": 461.4087,
    "sigma": 0.9524,
    "source": "Switch back",
    "passed_tracks": [],
    "shift_count": 0,
    "diff_cl_percent": -0.001728,
    "diff_sigma_percent": -0.399987,
    "switch_back_to_id": 9,
    "date": "2026-10-26 06:00:49.789507+00:00",
    "can_switch": false,
    "performed_by": "ผู้ใช้งาน",
    "reason": "Test switch back dry run",
    "status": "ใช้งานอยู่"
  }
];
const mockStores = new Map();
let activeMockKey = '';
const clone = (value) => JSON.parse(JSON.stringify(value));
function getMockRows(params) {
  const key = JSON.stringify([params?.plant_id, params?.factory_code, params?.line, params?.material_description]);
  activeMockKey = key;
  if (!mockStores.has(key)) mockStores.set(key, clone(MOCK_INITIAL_ROWS));
  return mockStores.get(key);
}
function mockRequest(params, body) {
  if (baselineConfig.mockScenario === 'empty') {
    if (body) throw new Error('ไม่มี Baseline สำหรับ Switch');
    return { body: { items: [], total: 0, current_shift_count: 21 } };
  }
  if (!body) {
    const all = getMockRows(params);
    return { body: { items: clone(sortRows(all).slice(0, Number(params?.limit) || 10)), total: all.length,
      current_baseline: clone(all.find(r => r.status === 'ใช้งานอยู่') || null) } };
  }
  const all = mockStores.get(activeMockKey) || [];
  const target = all.find(r => r.id === body.target_id);
  const current = all.find(r => r.status === 'ใช้งานอยู่');
  if (!target?.can_switch || !current || !String(body.reason || '').trim()) throw new Error('เลือก Baseline และกรอกเหตุผลก่อน Switch');
  const next = { ...clone(target), id: Math.max(...all.map(r => r.id)) + 1,
    no: Math.max(...all.map(r => r.no)) + 1, date: new Date().toISOString(),
    source: 'Switch back', switch_back_to_id: target.id, passed_tracks: [], shift_count: 0,
    performed_by: 'ผู้ใช้งาน (Mock)', reason: body.reason.trim(), can_switch: false, status: 'ใช้งานอยู่',
    diff_cl_percent: percentChange(target.cl, current.cl), diff_sigma_percent: percentChange(target.sigma, current.sigma) };
  all.forEach(r => { if (r.status === 'ใช้งานอยู่') r.status = '-'; });
  all.push(next);
  return { statusCode: 200, body: { success: true, mock: true } };
}

export const parsePayload = (input) => {
  let value = input;
  for (let i = 0; i < 5; i += 1) {
    if (typeof value === 'string') { value = JSON.parse(value); continue; }
    if (value?.statusCode && Number(value.statusCode) >= 400) {
      throw new Error('Baseline API error: ' + value.statusCode);
    }
    if (value && !Array.isArray(value) && Object.prototype.hasOwnProperty.call(value, 'body')) {
      value = value.body; continue;
    }
    return value;
  }
  throw new Error('รูปแบบ response ไม่ถูกต้อง');
};
export const unpackHistory = (input) => {
  const value = parsePayload(input);

  const rows = Array.isArray(value)
    ? value
    : value?.data ?? value?.items;

  if (!Array.isArray(rows)) {
    throw new Error('รูปแบบข้อมูล Baseline จาก API ไม่ถูกต้อง');
  }

  return {
    rows,
    total: Array.isArray(value) ? null : value?.total ?? null,
    current: Array.isArray(value)
      ? null
      : value?.current_baseline ?? null,
    currentShiftCount: Array.isArray(value)
      ? null
      : value?.current_shift_count ?? null,
  };
};
export const sortRows = (rows) => [...rows].sort((a, b) => Number(b.no) - Number(a.no) || Number(b.id) - Number(a.id));
export const numberOrNull = (v) => v == null || v === '' || !Number.isFinite(Number(v)) ? null : Number(v);
export const percentChange = (next, current) => {
  const a = numberOrNull(next); const b = numberOrNull(current);
  return a === null || b === null || b === 0 ? null : (a - b) / b;
};
export const baselineDate = (value) => {
  // PostgreSQL timestamp with microseconds -> ISO, explicit Bangkok display.
  const date = new Date(String(value || '').trim().replace(' ', 'T').replace(/(\.\d{3})\d+/, '$1'));
  if (!Number.isFinite(date.getTime())) return '-';
  return new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Bangkok', day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).format(date);
};
export async function requestBaseline(url, { params, body, signal } = {}) {
  if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
  if (baselineConfig.mock) return mockRequest(params, body);
  if (!url) throw new Error('กรุณาตั้งค่า URL ของ Baseline API ใน baselineApi.js');
  const config = { params, signal, headers: baselineConfig.getHeaders() };
  // console.log('[Baseline] Request:', {
  //   method: body ? 'POST' : 'GET',
  //   url: axios.getUri({ url, params }),
  //   params,
  // });
  
  const response = body
    ? await axios.post(url, body, config)
    : await axios.get(url, config);
  const data = response.data;
  console.log('[Baseline] HTTP status:', response.status);
  console.log('[Baseline] Response:', JSON.stringify(data, null, 2));
  const payload = parsePayload(data);
  if (body && payload?.success === false) {
    throw new Error('API ไม่สามารถสลับ Baseline ได้');
  }
  return data;
}

export const loadLatest = async (params, signal) => unpackHistory(await requestBaseline(baselineConfig.historyUrl, { params, signal }));
export async function exportAll(params) {
  if (!baselineConfig.mock && typeof baselineConfig.fetchAll !== 'function') {
    throw new Error('ต้องตั้งค่า fetchAll ตาม API ที่ดึงประวัติทั้งหมดก่อน Export Excel');
  }
  const result = baselineConfig.mock ? (baselineConfig.mockScenario === 'empty' ? [] : clone(getMockRows(params))) : await baselineConfig.fetchAll(params);
  if (!Array.isArray(result)) throw new Error('fetchAll ต้องคืน array ของประวัติทั้งหมด');
  if (!result.length) throw new Error('ไม่มีข้อมูลสำหรับ Export');
  const XLSX = await import('xlsx');
  const rows = [...sortRows(result)].reverse().map((r) => ({
    ID: r.id, No: r.no, 'Date (Asia/Bangkok)': baselineDate(r.date),
    CL: numberOrNull(r.cl), LCL: numberOrNull(r.lcl), UCL: numberOrNull(r.ucl), Sigma: numberOrNull(r.sigma),
    'Diff CL (%)': numberOrNull(r.diff_cl_percent) === null ? null : Number(r.diff_cl_percent) * 100,
    'Diff Sigma (%)': numberOrNull(r.diff_sigma_percent) === null ? null : Number(r.diff_sigma_percent) * 100,
    Tracks: (r.passed_tracks || []).join(', '), Shifts: r.shift_count,
    Source: r.source, 'Switch back to ID': r.switch_back_to_id, 'Performed by': r.performed_by,
    Reason: r.reason, Status: r.status,
  }));
  const sheet = XLSX.utils.json_to_sheet(rows);
  sheet['!cols'] = Object.keys(rows[0]).map(() => ({ wch: 22 }));
  const book = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(book, sheet, 'Baseline Log');
  const safe = String(params.material_description).replace(/[^a-zA-Z0-9_-]/g, '_');
  XLSX.writeFile(book, `${baselineConfig.mock ? 'MOCK_' : ''}Baseline_Log_${params.line}_${safe}.xlsx`);
}
